import React, { useState, useEffect } from "react";

const AboutUs = () => {
  const [activeTab, setActiveTab] = useState("Vision");

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  useEffect(() => {
    // Testimonial slider functionality (same as Portfolio)
    const slides = document.querySelectorAll(".slide");
    const thumbnails = document.querySelectorAll(".thumbnail");
    let slideInterval;
    let currentIndex = 0;

    const showSlide = (index) => {
      slides.forEach((slide) => slide.classList.remove("active"));
      thumbnails.forEach((thumbnail) => thumbnail.classList.remove("active"));

      if (slides[index]) slides[index].classList.add("active");
      if (thumbnails[index]) thumbnails[index].classList.add("active");

      currentIndex = index;
    };

    const nextSlide = () => {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    };

    const startAutoSlide = () => {
      slideInterval = setInterval(nextSlide, 5000);
    };

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener("click", () => {
        clearInterval(slideInterval);
        showSlide(index);
        startAutoSlide();
      });
    });

    if (slides.length > 0) {
      showSlide(0);
      startAutoSlide();
    }

    return () => {
      clearInterval(slideInterval);
    };
  }, []);

  return (
    <div className="about-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container">
            <h1 className="wow fadeInUp" data-wow-delay="0.3s">
              About Us
            </h1>
          </div>
        </div>
      </section>

      <section className="sub-section">
        <div className="container">
          <div className="wow fadeInUp title we-are">
            <h2>Who we are</h2>
            <p>
              A premier technology company with a global footprint. Our team is
              our greatest strength-technically proficient and rich in
              experience, committed to creating unique and business-effective
              solutions for startups and enterprises, setting new standards in
              innovation and quality.
            </p>
          </div>
          <div className="wow fadeInUp title we-are">
            <h2>What we do</h2>
            <p>
              We are proud to be an AI-empowered software development company
              that delivers flawless software solutions with remarkable speed.
              Our innovative mobile and web applications, shaped by unique
              visions, have been utilized by top brands, SMEs, and startups.
            </p>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>OUR VALUES</span>
          </div>
          <div className="title wow fadeInUp">
            <h2>What We Believe</h2>
            <p>
              Slash Star values shape its culture, always encouraging to develop
              and deliver disruptive innovations, as well as define
              relationships with clients, employees and community as a whole.
            </p>
          </div>

          {/* Desktop View */}
          <div className="industry-expertise-data wow fadeInUp">
            <div className="industry-expertise-content">
              <ul>
                <li
                  className={`industry-data tablinks ${
                    activeTab === "Vision" ? "active" : ""
                  }`}
                  onMouseOver={() => handleTabChange("Vision")}
                >
                  Our Vision
                </li>
                <li
                  className={`industry-data tablinks ${
                    activeTab === "Mission" ? "active" : ""
                  }`}
                  onMouseOver={() => handleTabChange("Mission")}
                >
                  Our Mission
                </li>
                <li
                  className={`industry-data tablinks ${
                    activeTab === "Policy" ? "active" : ""
                  }`}
                  onMouseOver={() => handleTabChange("Policy")}
                >
                  Quality Policy
                </li>
              </ul>
            </div>
            <div className="tabdata">
              <div
                className={`tabcontentvalue ${
                  activeTab === "Vision" ? "active" : ""
                }`}
                id="Vision"
                style={{
                  display: activeTab === "Vision" ? "flex" : "none",
                }}
              >
                <h3>Our Vision</h3>
                <p>
                  Our vision is to become the trusted technology partners of our
                  clients, contributing significantly to their success. We aim
                  to provide out-of-the-box solutions that are unique and
                  remarkable, helping our clients achieve their goals and stand
                  out in their respective industries.
                </p>
              </div>
              <div
                className={`tabcontentvalue ${
                  activeTab === "Mission" ? "active" : ""
                }`}
                id="Mission"
                style={{
                  display: activeTab === "Mission" ? "flex" : "none",
                }}
              >
                <h3>Our Mission</h3>
                <p>
                  Our mission is to empower and elevate our business clients by
                  creating a standout digital presence. Through innovative and
                  customer-focused mobile and web solutions, we strive to equip
                  our clients with the tools they need to thrive in the digital
                  world.
                </p>
              </div>
              <div
                className={`tabcontentvalue ${
                  activeTab === "Policy" ? "active" : ""
                }`}
                id="Policy"
                style={{
                  display: activeTab === "Policy" ? "flex" : "none",
                }}
              >
                <h3>Quality Policy</h3>
                <p>
                  We are dedicated to being the voice of quality, committed to
                  delivering flawless digital solutions that align with our
                  clients' needs and business objectives. Our unwavering
                  dedication ensures every project meets the highest standards
                  of excellence and reliability.
                </p>
              </div>
            </div>
          </div>

          {/* Mobile View */}
          <div className="values-part wow fadeInUp">
            <div>
              <h3>Our Vision</h3>
              <p>
                Our vision is to become the trusted technology partners of our
                clients, contributing significantly to their success. We aim to
                provide out-of-the-box solutions that are unique and remarkable,
                helping our clients achieve their goals and stand out in their
                respective industries.
              </p>
            </div>
            <div>
              <h3>Our Mission</h3>
              <p>
                Our mission is to empower and elevate our business clients by
                creating a standout digital presence. Through innovative and
                customer-focused mobile and web solutions, we strive to equip
                our clients with the tools they need to thrive in the digital
                world.
              </p>
            </div>
            <div>
              <h3>Quality Policy</h3>
              <p>
                We are dedicated to being the voice of quality, committed to
                delivering flawless digital solutions that align with our
                clients' needs and business objectives. Our unwavering
                dedication ensures every project meets the highest standards of
                excellence and reliability.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>WHY choose US</span>
          </div>
          <div className="title wow fadeInUp">
            <h2>
              We are <span className="gradient-text">curious, ambitious</span>{" "}
              and{" "}
              <span className="gradient-text">
                always
                <br /> stay open minded
              </span>
            </h2>
          </div>
          {/* Desktop */}
          <div className="why-us-content why-us-desktop wow fadeInUp">
            <div className="why-us-datas">
              <div>
                <h3>Curiousity</h3>
                <p>
                  We constantly seek new knowledge and approaches to improve our
                  software development process, resulting in cutting-edge
                  solutions that meet the needs of our clients.
                </p>
              </div>
              <div>
                <h3>Transparency</h3>
                <p>
                  We believe in transparency, and we strive to maintain open
                  communication channels with our clients throughout the
                  software development process.
                </p>
              </div>
              <div>
                <h3>Investigation</h3>
                <p>
                  We perform thorough investigations into our clients' business
                  processes, challenges, and goals to understand their specific
                  needs.
                </p>
              </div>
            </div>

            <div className="why-us-datas">
              <div>
                <h3>Gut Feeling</h3>
                <p>
                  Our team's passion and intuition fuel our work, ensuring that
                  we deliver high-quality solutions that exceed our clients'
                  expectations.
                </p>
              </div>
              <div>
                <h3>Ideation</h3>
                <p>
                  We encourage ideation and collaboration within our team,
                  fostering an environment that promotes creativity, innovation,
                  and problem-solving.
                </p>
              </div>
            </div>

            <div className="why-us-datas">
              <div>
                <h3>Follow up</h3>
                <p>
                  We are committed to our clients' success, and we provide
                  ongoing support and maintenance to ensure that our software
                  solutions remain up-to-date and continue to provide value.
                </p>
              </div>
            </div>
          </div>
          {/* Mobile */}
          <div className="why-us-content why-us-mobile wow fadeInUp">
            <div>
              <h3>Curiousity</h3>
              <p>
                We constantly seek new knowledge and approaches to improve our
                software development process, resulting in cutting-edge
                solutions that meet the needs of our clients.
              </p>
            </div>
            <div>
              <h3>Transparency</h3>
              <p>
                We believe in transparency, and we strive to maintain open
                communication channels with our clients throughout the software
                development process.
              </p>
            </div>
            <div>
              <h3>Investigation</h3>
              <p>
                We perform thorough investigations into our clients' business
                processes, challenges, and goals to understand their specific
                needs.
              </p>
            </div>
            <div>
              <h3>Gut Feeling</h3>
              <p>
                Our team's passion and intuition fuel our work, ensuring that we
                deliver high-quality solutions that exceed our clients'
                expectations.
              </p>
            </div>
            <div>
              <h3>Ideation</h3>
              <p>
                We encourage ideation and collaboration within our team,
                fostering an environment that promotes creativity, innovation,
                and problem-solving.
              </p>
            </div>
            <div>
              <h3>Follow up</h3>
              <p>
                We are committed to our clients' success, and we provide ongoing
                support and maintenance to ensure that our software solutions
                remain up-to-date and continue to provide value.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section owners">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Our Team</span>
          </div>
          <div className="title wow fadeInUp team-titles">
            <h2>
              <span className="gradient-text">Guiding Lights:</span>
              <br /> Our Leadership Team
            </h2>
            <p>
              Introducing the dynamic team leading us to new heights. Our
              executives combine industry experience with visionary leadership
              to drive our company's growth and success.
            </p>
          </div>
          <div className="row">
            <div className="col col-4 wow fadeInUp owners-card">
              <div className="team-img">
                <img src="/assets/images/owner/Shravan.png" alt="Shravan" />
              </div>
              <div className="owners-names">
                <div>
                  <h3>Shravan Vavadiya</h3>
                  <h4>CEO</h4>
                </div>
                <a
                  href="https://in.linkedin.com/in/shravan-vavadiya?trk=public_profile_browsemap-profile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/images/icon/linkedin-orignal.svg"
                    alt="Linkedin"
                  />
                </a>
              </div>
            </div>
            <div className="col col-4 wow fadeInUp owners-card">
              <div className="team-img">
                <img src="/assets/images/owner/Hiren.png" alt="Hiren" />
              </div>
              <div className="owners-names">
                <div>
                  <h3>Hiren Vavadiya</h3>
                  <h4>CTO</h4>
                </div>
                <a
                  href="https://in.linkedin.com/in/vavadiya-hiren-0225727b"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/images/icon/linkedin-orignal.svg"
                    alt="Linkedin"
                  />
                </a>
              </div>
            </div>
            <div className="col col-4 wow fadeInUp owners-card">
              <div className="team-img">
                <img src="/assets/images/owner/Devashish.png" alt="Devashish" />
              </div>
              <div className="owners-names">
                <div>
                  <h3>Devashish Vavadiya</h3>
                  <h4>COO</h4>
                </div>
                <a
                  href="https://in.linkedin.com/in/devashish-vavadiya-b4243374"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/images/icon/linkedin-orignal.svg"
                    alt="Linkedin"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="culture-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Our Culture</span>
          </div>
          <div className="title wow fadeInUp">
            <h2>
              Our <span className="gradient-text">Culture in Action</span> :
              <br /> Work, Play, Celebrate
            </h2>
            <p>
              Experience the lively atmosphere of our workplace, marked by
              commitment, fun, and collective achievements.
            </p>
          </div>

          <div className="culture-main desktop wow fadeInUp">
            <div className="images">
              <img src="/assets/images/culture/1.svg" alt="culture" />
            </div>
            <div className="culture-images-part">
              <div className="culture-secound">
                <div className="images">
                  <img src="/assets/images/culture/2.svg" alt="activities" />
                </div>
                <div className="images">
                  <img src="/assets/images/culture/3.svg" alt="Fun-time" />
                </div>
              </div>
              <div className="culture-secound">
                <div className="images">
                  <img src="/assets/images/culture/4.svg" alt="engagement" />
                </div>
                <div className="images">
                  <img src="/assets/images/culture/5.svg" alt="event" />
                </div>
              </div>
            </div>
          </div>

          <div className="mobile wow fadeInUp">
            <div className="images">
              <img src="/assets/images/culture/4.svg" alt="festival" />
            </div>
            <div className="culture-main">
              <div className="images">
                <img src="/assets/images/culture/1.svg" alt="office-time" />
              </div>
              <div>
                <div className="culture-secound">
                  <div className="images">
                    <img src="/assets/images/culture/2.svg" alt="function" />
                  </div>
                  <div className="images">
                    <img src="/assets/images/culture/5.svg" alt="games" />
                  </div>
                </div>
              </div>
            </div>
            <div className="culture-third">
              <div className="images">
                <img src="/assets/images/culture/3.svg" alt="enjoyment" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="clients-section clients-section-background">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Clients</span>
          </div>
          <div className="title wow fadeInUp">
            <h2>
              We’ve <span className="gradient-text">teamed up</span> with some{" "}
              <span className="gradient-text">great people</span> over the years
            </h2>
          </div>
          <div className="clint-logos wow fadeInUp">
            <div className="about-logo">
              <img src="/assets/images/logos/dark-home.svg" alt="Home" />
            </div>
            <div className="about-logo">
              <img src="/assets/images/logos/dark-wom.svg" alt="Wom" />
            </div>
            <div className="about-logo">
              <img
                src="/assets/images/logos/dark-leosphere.svg"
                alt="Leosphere"
              />
            </div>
            <div className="about-logo">
              <img src="/assets/images/logos/dark-linde.svg" alt="Linde" />
            </div>
            <div className="about-logo">
              <img src="/assets/images/logos/cashback.svg" alt="cashback" />
            </div>
            <div className="about-logo">
              <img src="/assets/images/logos/pwr-dark.svg" alt="pwr" />
            </div>
          </div>
        </div>
      </section>

      <section className="platforms-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Platforms</span>
          </div>
          <div className="title wow fadeInUp">
            <h2>
              <span className="gradient-text">Digital Discovery</span> :<br />{" "}
              Explore Our Profiles
            </h2>
          </div>
          <div className="wow fadeInUp platforms-content wow fadeInUp">
            <a
              className="platforms-part dribbble"
              href="https://dribbble.com/slashstar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <img
                  src="/assets/images/icon/dribbble-logo.png"
                  alt="Dribbble"
                />
              </div>
              <h2>Dribbble</h2>
            </a>
            <a
              className="platforms-part behance"
              href="https://www.behance.net/slashstar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <img src="/assets/images/icon/behance-logo.png" alt="Behance" />
              </div>
              <h2>Behance</h2>
            </a>
            <a
              className="platforms-part github"
              href="https://github.com/slashstar-co"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <img src="/assets/images/icon/github-logo.png" alt="GitHub" />
              </div>
              <h2>GitHub</h2>
            </a>
          </div>
        </div>
      </section>

      {/* Testimonial Section - Same as Portfolio */}
      <section className="testimonial-section">
        <div className="container wow fadeInUp">
          <div className="title-small wow fadeInUp">
            <span>Testimonial</span>
          </div>
          <div className="title">
            <h2>
              <span className="gradient-text">Empowered Partnerships </span>:
              <br />
              Testimonials that Inspire
            </h2>
          </div>
          <div className="tabs">
            <div className="slider-wrapper">
              <div className="slider mySwiper">
                <div className="slide active">
                  <div className="testimonial-tabs-data">
                    <div className="reviews-video">
                      <a
                        href="https://www.youtube.com/watch?v=bTKUX-WEBt4"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/assets/images/reviews/klokbox/klokbox.png"
                          alt="klokbox"
                        />
                      </a>
                    </div>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/klokbox/user.jpg"
                            alt="Client-klokbox"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Daniel Culloty</h4>
                          <h5>CEO, Klokbox</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/danielculloty/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="danielculloty"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <div className="reviews-video">
                      <a
                        href="https://www.youtube.com/watch?v=MWYh9wbWv_g"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/assets/images/reviews/autobiography/autobio.png"
                          alt="autobiography"
                        />
                      </a>
                    </div>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/autobiography/cliant.png"
                            alt="Client-autobiography"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Arie Botbol</h4>
                          <h5>CEO, Stealth Mode</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/ariebotbol/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="ariebotbol"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <p>
                      Thanks to team's expertise in Flutter, our food tracker
                      and calorie counter app for the French market has been a
                      tremendous success. We look forward to a long-term
                      partnership for future updates and maintenance.
                    </p>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/ltg/client-ltg.jpg"
                            alt="Client-ltg"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Marion Grassia</h4>
                          <h5>CEO , LAISSE-TOI GUIDER</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/marion-grassia-85095322a/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="marion-grassia"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <p>
                      Slash Star turned my team's concept of a mobile app
                      connecting via Bluetooth and web 3.0 into an astounding
                      reality. Their professionalism, transparent communication,
                      development speed, and technical expertise were evident
                      throughout the project. The end result was a seamlessly
                      designed app that effortlessly integrates Bluetooth
                      connectivity. For anyone seeking a dedicated development
                      partner that transforms ideas into technological
                      brilliance, I wholeheartedly recommend Slash Star.
                    </p>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/nilo/image.png"
                            alt="Client-nilo"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Seung Hwan Lee</h4>
                          <h5>CEO, Nilo.gg</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/seungh-lee/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="seungh-lee"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <p>
                      We were able to successfully complete the project by
                      meeting the best partner. They have a very good
                      understanding of development and skills, and are fully
                      committed to the task schedule. The time we met and spent
                      with them is lucky for us. We'll always work on the
                      project with them.
                    </p>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/finutzz/user.jpg"
                            alt="finutss-user"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Min Suk Kim</h4>
                          <h5>CEO, Nine Peace Co. Ltd.</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/min-suk-kim-9040311b2/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="min-suk-kim"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <p>
                      The team delivered a super functional product, within an
                      impressive timeframe, that has stood the test of time
                      through the growth of our user base. They have been
                      extremely responsive all throughout.
                    </p>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/telly/client-telly.jpg"
                            alt="Telly"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Karen Zhao</h4>
                          <h5>Co-founder, Telly</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/karenzhao2/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="karen zhao"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="thumbnails">
              <div className="thumbnail active" data-slide="0">
                <img
                  src="/assets/images/logos/logo-klokbox-1.svg"
                  alt="Thumb 1"
                />
              </div>
              <div className="thumbnail" data-slide="1">
                <img
                  src="/assets/images/reviews/autobiography/logo.png"
                  alt="Thumb 2"
                />
              </div>
              <div className="thumbnail" data-slide="2">
                <img src="/assets/images/logos/logo-ltg.svg" alt="Thumb 3" />
              </div>
              <div className="thumbnail" data-slide="3">
                <img
                  src="/assets/images/logos/nilo-orignal.svg"
                  alt="Thumb 4"
                />
              </div>
              <div className="thumbnail" data-slide="4">
                <img
                  src="/assets/images/logos/logo-finutss-1.svg"
                  alt="Thumb 5"
                />
              </div>
              <div className="thumbnail" data-slide="5">
                <img src="/assets/images/logos/dark-telly.svg" alt="Thumb 6" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
